/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerAdminModel } from '../../models/practitioner-admin-model';

export interface AdminPersonIdGet$Params {
  personId: string;
}

export function adminPersonIdGet(http: HttpClient, rootUrl: string, params: AdminPersonIdGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<PractitionerAdminModel>> {
  const rb = new RequestBuilder(rootUrl, adminPersonIdGet.PATH, 'get');
  if (params) {
    rb.path('personId', params.personId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PractitionerStrictHttpResponse<PractitionerAdminModel>;
    })
  );
}

adminPersonIdGet.PATH = '/Admin/{personId}';
